import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { AuthProvider, useAuth } from '@/contexts/AuthContext'
import { BrandedLoader } from '@orrekie/ui';
import { BrowserRouter as Router } from 'react-router-dom';

function Root() {
  const { loading } = useAuth();
  if (loading) {
    return <BrandedLoader message="Loading authentication, please wait…" />;
  }
  // Only mount the router after loading is false
  return (
    <Router>
      <App />
    </Router>
  );
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <AuthProvider>
      <Root />
    </AuthProvider>
  </StrictMode>,
)
